import { useEffect } from "react"
import { useEditorEventBusInstance } from "../../events/useEventBusInstance"
import { cellToNodeState } from "../../services/storage"
import { EquipmentType } from "@/services/project/equipment/enums"
import { deleteManualInput } from "@/services/project/simulation.service"
import { Node } from "@antv/x6"
import { NodeShapes } from "../../services/modal"
import { getFlowSimulationSelector } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"

export function FlowEvents() {
  const eventBus = useEditorEventBusInstance()
  const flowSimulation = useSelector(getFlowSimulationSelector)


  useEffect(() => {
    if (!flowSimulation?.id) {
      return
    }
    const handleNozzleChanged = async ({node, type}) => {
      if (node.shape !== NodeShapes.SvgNode) return;
      const unit = cellToNodeState(node)
      if (unit.equipment.type === EquipmentType.StreamSplitter) {
        if (type === 'remove') {
          const ports = (node as Node).getPorts().filter(item => item.data.name.startsWith('OUT'))
          ports.forEach((port, index) => {
            (node as Node).setPortProp(port.id!, 'data', {... port.data, name: `OUT${index}`})
          })
        }
        const newUnit = cellToNodeState(node)
        const vars = newUnit.nozzles.filter(item => item.name.startsWith('OUT')).map((item, index) => {
          return {
            unitId: newUnit.id,
            attribute: `:${item.name}:ETA`
          }
        })
        try { 
          await deleteManualInput({dvars: vars}, {sId: flowSimulation.id})
        } catch (error) {
          console.error(error)
        }
        eventBus.trigger('unit:changed', {node})
      }
    }
    eventBus.on('node:nozzle:changed', handleNozzleChanged)

    return () => {
      eventBus.off('node:ports:changed', handleNozzleChanged)
    }
  }, [eventBus, flowSimulation])
  return null
}